import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffScheduleRequestsSigmecIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      staff_id: '',
      data: [],
      schedule_request: {}
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.openModal = this.openModal.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.confirmChangeStatus = this.confirmChangeStatus.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var id = null;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/escala/solicitacoes';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({data: responseJson.data.main, staff_id: responseJson.data.staff_id});
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  openModal (schedule_request_id) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/escala/solicitacao/' + schedule_request_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.setState({schedule_request: responseJson.data, modal: true});
        self.handleAlert('', '', 'closed');
      });
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn button-inline btn-sm btn-primary" value={cell} onClick={() => { this.openModal(cell) }}>
          <i className="fa fa-fw fa-tasks"></i>
        </button>
        {(row.status == 'additional_info_pending') ?
            <button className="btn button-inline btn-sm btn-warning" onClick={() => { this.changeStatus(cell, 'additional_info_pending', row.additional_info_request) }}>
              <i className="fa fa-reply"></i>
            </button>
        : (row.status == 'additional_approval_pending' && row.approval_staff_id == this.state.staff_id) ?
            <button className="btn button-inline btn-sm btn-info" onClick={() => { this.changeStatus(cell, 'additional_approval_pending', row.additional_info_request, null) }}>
              <i className="fa fa-reply"></i>
            </button>
        : ''
        }
      </div>
    );

    return botao;
  }

  changeStatus (schedule_request_id, value, additional_info_request, additional_info_answer) {
    this.setState({additional_info_modal: true, change_status: value, schedule_request_id: schedule_request_id, additional_info_request: additional_info_request, additional_info_answer: additional_info_answer});
  }
  
  confirmChangeStatus (status) {
    if(window.confirm(this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.confirmarMudanca)) {
      var datasave = {
        type: 'colaborador',
        schedule_request_id: this.state.schedule_request_id,
        additional_info_answer: this.state.additional_info_answer,
        change_status: status,
      };
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/escala/solicitacao/status', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({data: responseJson.data.main, staff_id: responseJson.data.staff_id, schedule_request_id: null, change_status: null, additional_info_modal: false, reason: null});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
  
    }
  }

  exportMedicalCertificate (url) {
    window.open(config.get('cdn_sigmec') + '/files/atestados/' + url);
  }

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title">{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.titulo}</h3>
        <hr/>
        <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.semDados}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
        
            <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.ID}</TableHeaderColumn>
            <TableHeaderColumn dataField="schedule" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Escala}</TableHeaderColumn>
            <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='250'>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Colaborador}</TableHeaderColumn>
            <TableHeaderColumn dataField="change_type_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.TipoDeSolicitacao}</TableHeaderColumn>
            <TableHeaderColumn dataField="reason" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='250'>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Justificativa}</TableHeaderColumn>
            <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Status}</TableHeaderColumn>
            <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} dataSort={false} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Acoes}</TableHeaderColumn>

        </BootstrapTable>

        {/* Modal de detalhamento da solicitação */}
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.titulo}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>

            <div className="row">
                <div className="col-md-6 form-group">
                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.EscalasMesAtual}l</label>
                    <input type="text" name="schedule" className="form-control" disabled value={this.state.schedule_request.schedule} />
                </div>
                <div className="col-md-6 form-group">
                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Colaborador}</label>
                    <input type="text" name="staff" className="form-control" disabled value={this.state.schedule_request.staff} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 form-group">
                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.TipoDeAlteracao}</label>
                    <input type="text" name="change_type_str" className="form-control" disabled value={this.state.schedule_request.change_type_str} />
                </div>
                <div className="col-md-6 form-group">
                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Solicitante}</label>
                    <input type="text" name="user" className="form-control" disabled value={this.state.schedule_request.user} />
                </div>
            </div>
            {this.state.schedule_request.change_type == 'change_group' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.GrupoAtual}</label>
                            <input type="text" name="current_schedule_group" className="form-control" disabled value={this.state.schedule_request.current_group} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Novogrupo}</label>
                            <input type="text" name="new_schedule_group" className="form-control" disabled value={this.state.schedule_request.new_group} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio}:</label>
                            <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Definitiva}</label>
                                <br/>
                                <input type="text" name="definitive_change_str" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                            </div>
                        </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino}:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_regime' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.QuinzenaAtual}</label>
                            <input type="text" name="current_regime" className="form-control" disabled value={this.state.schedule_request.current_regime} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaQuinzena}</label>
                            <input type="text" name="new_regime" className="form-control" disabled value={this.state.schedule_request.new_regime} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio}:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_base' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.BaseAtual}</label>
                            <input type="text" name="current_base" className="form-control" disabled value={this.state.schedule_request.current_base} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaBase}</label>
                            <input type="text" name="new_base" className="form-control" disabled value={this.state.schedule_request.new_base} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio}:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Definitiva}?</label>
                                <br/>
                                <input type="text" name="definitive_change_str" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                            </div>
                        </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino}:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                    
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_period' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.PeriodoAtual}</label>
                            <input type="text" name="current_schedule_period" className="form-control" disabled value={this.state.schedule_request.current_schedule_period} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaPeriodo}</label>
                            <input type="text" name="new_schedule_period" className="form-control" disabled value={this.state.schedule_request.new_schedule_period} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio}:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }

            {this.state.schedule_request.change_type == 'change_role' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.FuncaoAtual}</label>
                            <input type="text" name="current_role" className="form-control" disabled value={this.state.schedule_request.current_role} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaFuncao}</label>
                            <input type="text" name="new_role" className="form-control" disabled value={this.state.schedule_request.new_role} />
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio}:</label>
                            <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Definitiva}?</label>
                            <br/>
                            <input type="text" name="definitive_change_str" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                        </div>
                    </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino}:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NumeroChamado}:</label>
                                    <input type="text" name="request_number" className="form-control" disabled value={this.state.schedule_request.request_number} />
                                </div>
                            </div>
                        </div>
                        : 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NumeroMp}:</label>
                                    <input type="text" name="mp_number" className="form-control" disabled value={this.state.schedule_request.mp_number} />
                                </div>
                            </div>
                        </div>
                    }
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'change_absences' ? 
                <div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio}:</label>
                                <input type="text" name="date_start_str" className="form-control" disabled value={this.state.schedule_request.date_start_str} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.TempoIndeterminado}?</label>
                                <br/>
                                <input type="text" name="schedule" className="form-control" disabled value={this.state.schedule_request.definitive_change_str} />
                            </div>
                        </div>
                    </div>
                    {this.state.schedule_request.definitive_change == false ? 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino}:</label>
                                    <input type="text" name="date_finish_str" className="form-control" disabled value={this.state.schedule_request.date_finish_str} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Atestado}:</label>
                                    <br></br>
                                    <button onClick={() => this.exportMedicalCertificate(this.state.schedule_request.file)} className="btn btn-primary" value={this.state.schedule_request.id}>
                                      <i className="fa fa-fw fa-file-pdf-o"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Atestado}:</label>
                                    <br></br>
                                    <button onClick={() => this.exportMedicalCertificate(this.state.schedule_request.file)} className="btn btn-primary" value={this.state.schedule_request.id}>
                                      <i className="fa fa-fw fa-file-pdf-o"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                : ''
            }
            {this.state.schedule_request.change_type == 'other_changes' ? 
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Descricao}:</label>
                                <textarea value={this.state.schedule_request.description} name="description" className="form-control" placeholder="" disabled style={{height: '200px'}} required />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }
                    
            {this.state.schedule_request.change_type !== null && this.state.schedule_request.change_type !== 'change_absences' ? 
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Justificativa}:</label>
                                <textarea value={this.state.schedule_request.reason} disabled name="reason" className="form-control" placeholder="" style={{height: '200px'}} required />
                            </div>
                        </div>
                    </div>
                </div>
                : ''
            }


          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>

        {/* Modal de solicitação de informação/aprovação adicional */}
        <Modal show={this.state.additional_info_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.state.change_status == 'additional_approval_pending' ? 'Aprovação' : 'Informações'}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ additional_info_modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.Exigencia}:</label>
                  <textarea value={this.state.additional_info_request} name="additional_info_request" className="form-control" placeholder="" style={{height: '200px'}} disabled />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>{this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.Resposta}:</label>
                  <textarea value={this.state.additional_info_answer} name="additional_info_answer" className="form-control" onChange={this.handleChange.bind(this, 'additional_info_answer')} placeholder="" style={{height: '200px'}} required />
                </div>
              </div>
            </div>
            <div className="row">
                  {this.state.change_status == 'additional_info_pending' ?
                    <div className="col-md-12">
                      <button className="btn btn-lg btn-block btn-primary" onClick={() => { this.confirmChangeStatus('additional_info_acceptance_pending')}}>
                        <i className="fa fa-fw fa-save"></i> {this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.botaoEnviarInformacaos}
                      </button>
                    </div>
                  : (this.state.change_status == 'additional_approval_pending') ?
                      <div className="col-md-12">
                        <button className="btn btn-lg btn-block btn-success" onClick={() => { this.confirmChangeStatus('additional_approval_acceptance_pending')}}>
                          <i className="fa fa-fw fa-save"></i> {this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.botaoAprovar}
                        </button>
                        <button className="btn btn-lg btn-block btn-danger" onClick={() => { this.confirmChangeStatus('additional_approval_reproved') }}>
                          <i className="fa fa-fw fa-save"></i> {this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.botaoReprovar}
                        </button>
                      </div>
                  : ''
                  }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ additional_info_modal: false })}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>

    </div>
  </div>
</div>
    );
  }
}

export default StaffScheduleRequestsSigmecIndex;



// WEBPACK FOOTER //
// ./src/Components/StaffScheduleRequests/StaffScheduleRequestsSigmecIndex.js